(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iconic-card-list-first"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.iconic-card-list-wrap');

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        const overlay = card.querySelector('.iconic-overlay-text');
        if (overlay && overlay.firstElementChild) {
          const child = overlay.firstElementChild;
          const childHeight = child.offsetHeight;
          const hoverCard = card.querySelector('.iconic-image-hover-card');
          if (hoverCard) {
            hoverCard.style.setProperty('--child-height', `${childHeight}px`);
          }
        }
      });
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
